import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  icon?: ReactNode;
  actions?: ReactNode;
}

export default function PageHeader({ title, description, icon, actions }: PageHeaderProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, width: '100%', mb: 3 }}>
      <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start', minWidth: 0, flex: '1 1 260px' }}>
        {icon && <Box aria-hidden="true" sx={{ display: 'grid', placeItems: 'center', width: 40, height: 40, flexShrink: 0, borderRadius: 2, bgcolor: 'action.selected', color: 'primary.main', '& .MuiSvgIcon-root': { fontSize: 22 } }}>{icon}</Box>}
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 700, overflowWrap: 'anywhere' }}>{title}</Typography>
          {description && <Typography variant="body2" component="div" color="text.secondary" sx={{ mt: 0.75, maxWidth: 760 }}>{description}</Typography>}
        </Box>
      </Box>
      {actions && <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>{actions}</Box>}
    </Box>
  );
}
